import React from "react";
import Load from "./load";
import { ImagePathurl } from "../helper/constants";
import LazySection from "../components/about/LazySection";
import { useInvestorData } from "../hooks/useInvestorData";

const Investor: React.FC = () => {

     const PathUrl=ImagePathurl;
     const { image: InvImg,invdata: InvData, files: InvFile, loading } = useInvestorData();
    
// const noticesArray: any[] = [];
// const ReArray: any[] = [];
// for (let i = 0; i < InvFile.length; i++) {
//   const item = InvFile[i];

//   if (item.file_category === 'Notices') {
//     formatted.push({
//       id: item.id,
//       file_url: item.file_url,
//       file_title: item.file_title,
//       file_name: item.file_name
//     });
//   }
// }
console.log(InvData,"investors");
console.log(InvFile,"investors-file");

    if (loading) return    <Load />;
    // if (error) return <div>Error: {error}</div>;

return (
    <>
     
      <main className="main">

        {/* <!-- Hero Section --> */}
        <section id="hero" className="hero section investor-hero dark-background investor-banner" style={{minHeight:'60vh !important'}}>
            <img src={InvImg?.thumbnail?.[0]?.url}  alt={InvImg?.name?.[0]?.value || 'Investor'} className="hero-bg" loading="lazy" decoding="async" />

        </section>
        {/* <!-- /Hero Section -->
        <!-- About career Section --> */}
        <section id="about" className="about media-investor-file section pt-3 pt-md-5">

            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gx-2 align-items-xl-start gy-md-5 ">

                    <div className="col-xl-12 col-sm-12 content mt-4">
                        {/* <!--<h3>About Us</h3>--> */}
                        <label className="label-title">{InvData?.field_investor_title[0]?.value} </label>
                        <LazySection>
                          <ul className="annualreportlist list-unstyled">
                                 {InvFile.length > 0 ? (
                                      InvFile.filter((item: any) => item.file_category === 'notices' && item.status === true).sort((a: any, b:any) => b.id - a.id).map((inv, index) => (
                                      <li key={index}>
                                          <div className="report-list-item">
                                          
                                              <a href={`${PathUrl}${inv.file_url}`} target="_blank" rel="noopener noreferrer" title={inv.file_title}>
                                                  <i className="bi bi-file-pdf-fill text-danger"></i>{inv.file_title}
                                              </a>
                                          </div>
                                      </li>
                                      ))
                                          ) : (
                                              <p>No Data found.</p>
                                          )}
                                
                          </ul>
                        </LazySection>
                    </div>

                     <div className="col-xl-12 col-sm-12 content mt-4">
                        {/* <!--<h3>About Us</h3>--> */}
                       <label className="label-title">{InvData?.field_annual_return_form[0]?.value} </label>
                        <LazySection>
                          <ul className="annualreportlist list-unstyled">
                                 {InvFile.length > 0 ? (
                                      InvFile.filter((item: any) => item.file_category === 'return_form' && item.status === true).sort((a: any, b:any) => b.id - a.id).map((inv, index) => (
                                      <li key={index}>
                                          <div className="report-list-item">
                                          
                                              <a href={`${PathUrl}${inv.file_url}`} target="_blank" rel="noopener noreferrer" title={inv.file_title}>
                                                  <i className="bi bi-file-pdf-fill text-danger"></i>{inv.file_title}
                                              </a>
                                          </div>
                                      </li>
                                      ))
                                          ) : (
                                              <p>No Data found.</p>
                                          )}
                                
                          </ul>
                        </LazySection>
                    </div>

                </div>
            </div>

        </section>

    </main>


    </>
  )
}

export default Investor;